import { post, get } from './apiUtils';

const defaultUrl = '/DashboardTypes/';
const resultUrl = '/Results/';

export default {
  getDashboardResults: id => get(`${defaultUrl}${id}${resultUrl}`),
  getDashboardList: () => get(defaultUrl),
  getDashboard: id => post(`${defaultUrl}${id}`),
};
